import { useContext } from 'react'

import PageWrapper from '/components/page-wrapper'

import HelpText from '/help/account-management-password'
import { AppContext } from '/providers/app-context'

import Menu from '/components/account/nav-menu'
import PasswordAdmin from '/components/account/password'

const AccountManagementPassword = () => {

  const { client,user } = useContext(AppContext)

  return (
    <PageWrapper title="Profile" HelpText={HelpText} heading="Profile" menu={<Menu client={client} user={user} />}>
      <div className='flex flex-col gap-5 overflow-y-auto'>
        <PasswordAdmin />
      </div>
    </PageWrapper>
  )
}

export default AccountManagementPassword
